// extracted by mini-css-extract-plugin
export default {"recos":"s3-z","productCardOverride":"t3-z","rowHasBadge":"u3-z"};